export default __webpack_public_path__ + "static/hands-e82ba742265aafe98113faeb437b9c5e.mp4";